import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SplitDeck from './components/Home/SplitDeck';
import CaseStudyPage from './components/CaseStudy/CaseStudyPage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Split-deck home: same component serves three URLs, scrolling to the matching pane */}
        <Route path="/" element={<SplitDeck />} />
        <Route path="/case-studies" element={<SplitDeck />} />
        <Route path="/showcase" element={<SplitDeck />} />

        {/* Individual case study */}
        <Route path="/:slug" element={<CaseStudyPage />} />

        {/* Legacy redirects */}
        <Route path="/portfolio" element={<Navigate to="/" replace />} />
        <Route path="/portfolio/:caseId" element={<Navigate to="/" replace />} />

        {/* External / static destinations */}
        <Route path="/thoughts" element={<Navigate to="http://blog.gregjohnson.info" replace />} />
        <Route path="/background" element={<Navigate to="/background.html" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
